import { render, staticRenderFns } from "./Nosology.vue?vue&type=template&id=1047454c"
import script from "./Nosology.vue?vue&type=script&lang=js"
export * from "./Nosology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports